
import Vue from 'vue';
import EuButton from '../Button/Button.vue';
import EuCard from '../Card/Card.vue';
/**
- Generalcard can be a singular item or multiple with selectable function
- To turn GeneralCard into selection card, simply pass <b>selected</b> prop.
- Accepts Custom desc/list inside Body Content: with <b><template v-slot:list="props"></b> then to activate expand function, pass <b>v-if="props.expand"</b> inside tag that's supposed to show when expanded.
**/
export default Vue.extend<any, any, any, any>({
  name: 'GeneralCard',
  data() {
    return {
      expand: false,
      headerHeight: 0
    };
  },
  components: {
    EuButton,
    EuCard
  },
  props: {
    /**
     * Set id
     */
    id: {
      type: [Number, String],
      default: ''
    },
    /**
     * Set Card elevation type
     */
    elevation: {
      type: String,
      default: ''
    },
    /**
     * Set title
     */
    title: {
      type: String,
      default: ''
    },
    /**
     * Set subtitle
     */
    subtitle: {
      type: String,
      default: ''
    },
    /**
     * Set product Image
     */
    productImage: {
      type: String,
      default: ''
    },
    /**
     * Set product detail
     */
    productDetail: {
      type: String,
      default: ''
    },
    /**
     * Set view less label
     */
    viewLessDetailLabel: {
      type: String,
      default: ''
    },
    /**
     * Set view more label
     */
    viewMoreDetailLabel: {
      type: String,
      default: ''
    }
  },
  created() {
    this.getDetailHeight();
  },
  computed: {
    computedHeight() {
      if (this.expand) {
        return 'height: max-content; padding-bottom: 4px';
      }
      return this.headerHeight >= 70 && (this.viewLessDetailLabel || this.viewMoreDetailLabel) ? 'height: 70px' : '';
    },
    computedExpandLabel() {
      return this.expand ? this.viewLessDetailLabel : this.viewMoreDetailLabel;
    },
    showExpand() {
      if (this.headerHeight >= 70) {
        return true;
      }
      return false;
    }
  },
  methods: {
    expandDetail() {
      this.expand = !this.expand;
    },
    getDetailHeight() {
      this.$nextTick(() => {
        if (this.$refs.infoBox) {
          this.headerHeight = this.$refs.infoBox.clientHeight;
        }
      });
    },
    handleClickCard(e: any) {
      /**
       * Method to click card
       * @event click
       * @type {function}
       */
      this.$emit('click', e);
    },
    handleViewMore(e: any) {
      /**
       * Method to click view more on body section
       * @event clickview
       * @type {function}
       */
      this.$emit('clickview', e);
    },
    handleSecondaryButton(e: any) {
      /**
       * Method to click secondary button
       * @event clicksecondary
       * @type {function}
       */
      this.$emit('clicksecondary', e);
    },
    handlePrimaryButton(e: any) {
      /**
       * Method to click primary button
       * @event clickprimary
       * @type {function}
       */
      this.$emit('clickprimary', e);
    }
  }
});
